export class city{

    cityId : number;  
    cityID: number;
    cityName: string;
    countryId:number;
    countryName:string;
   // dateAdded:any;
    addedBy:string;
    // DateChanged:any;
    changedBy:string;
    Status:boolean;
}

export class UserCity{
    cityID : number;  
    cityName: string;

}
export class Practice{
    practiceId : number;  
    name: string;
}
